import { styled } from "@styles";

export const Wrapper = styled.div`
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

export const Content = styled.p``;

export const ImageIcon = styled.img`
  width: 9rem;
  padding: 3rem 0 1rem;
`;

export const P = styled.p`
  color: #11141D99;
  text-decoration: underline;
`;